import { createGlobalStyle } from 'styled-components'
import { Theme } from 'theme'

export const GlobalStyles = createGlobalStyle<{ theme: Theme }>``
